import { IEnableSpecifiable } from "./IEnableSpecifiable";

export class OptionalFeature implements IEnableSpecifiable {
  constructor(
    public isEnable: boolean = false,
  ) {
  }

  clone(): OptionalFeature {
    return new OptionalFeature(this.isEnable);
  }

  static from(source: IEnableSpecifiable): OptionalFeature {
    return new OptionalFeature(source.isEnable);
  }

  static to(source: OptionalFeature): IEnableSpecifiable {
    return {
      isEnable: source.isEnable,
    };
  }
}
